const SAVE = 'SAVE_THEBRANDS';

export function theBrandReducer (state = [], action) {
    switch (action.type) {
        case SAVE:
            return action.payload;
        default:
            return state;
    }
}